import { StyleSheet, View } from 'react-native';
import { styles as baseStyles, Icon, Text, theme } from '@socrait/react';

import { HyperLink } from '~/components/HyperLink';
import { handlePrivacyPolicyPress } from '~/constants';

export const PrivacySlide = () => {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>Privacy is Our Priority</Text>
      <View style={styles.privacyContainer}>
        <View style={styles.privacyItem}>
          <Icon type="checkedCircle" />
          <Text style={styles.text}>
            We stream your voice but <Text style={[styles.text, baseStyles.boldText]}>we don't record.</Text>
          </Text>
        </View>
        <View style={styles.privacyItem}>
          <Icon type="checkedCircle" />
          <Text style={styles.text}>
            We <Text style={[styles.text, baseStyles.boldText]}>remove student names</Text> before sending any requests
            to AI systems.
          </Text>
        </View>
        <View style={styles.privacyItem}>
          <Icon type="checkedCircle" />
          <Text style={styles.text}>
            Per our{' '}
            <HyperLink onPress={handlePrivacyPolicyPress} style={styles.text}>
              privacy policy
            </HyperLink>
            , <Text style={[styles.text, baseStyles.boldText]}>we will never sell your data.</Text>
          </Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignSelf: 'center',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    gap: theme.spacing.xxlarge,
    paddingHorizontal: theme.spacing.xxlarge,
    maxWidth: 750,
    width: '80%',
  },
  title: {
    fontSize: theme.fontSizes.xlarge,
    marginTop: -theme.spacing.xxlarge * 2,
  },
  privacyContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing.xlarge,
    paddingTop: theme.spacing.xxlarge,
  },
  privacyItem: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing.xlarge,
    width: '100%',
  },
  text: {
    fontSize: theme.fontSizes.xmedium,
    lineHeight: theme.lineHeights.medium,
    flex: 1,
  },
});
